import { env } from "./env";

export const routeToErrorPage = () => {
  window.location.href = `${env.REACT_APP_KEYCLOAK_URL}/realms/customer-portal-realm/error`;
};
